import intersection from 'lodash/intersection';
// The `fontawesomeIconList.json` file is generated by the `generateFontawesomeIconList.js`
// node script in the root folder of is-ui.
// The script creates the JSON file in the directory it's run in.
import jsonData from './fontawesomeIconList.json';

// Order result by weighted prop first and by key second
const sortResult = (a, b) => {
  if (b.weighted < a.weighted) {
    return -1;
  } else if (b.weighted > a.weighted) {
    return 1;
  } else if (b.key > a.key) {
    return -1;
  } else if (b.key < a.key) {
    return 1;
  }

  return 0;
};

const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
};

/*
 * Lookup icons for `search` term in the icon JSON
 *
 * Return a sorted result were full matches are valued higher than partial matches
 * and matches in the icons name are valued higher than matches in the icons description terms
 */
const lookupIcons = (search) => {
  const results = [];
  const safeSearch = escapeRegExp(search);
  Object.keys(jsonData).forEach((key) => {
    const rgxWord = new RegExp(`\\b${safeSearch}\\b`, 'i');
    const rgxPartial = new RegExp(`${safeSearch}`, 'i');
    const hitKey = rgxWord.test(key);
    const hitKeyPartial = rgxPartial.test(key);
    const hitTerm = jsonData[key].filter((term) => rgxWord.test(term));
    const hitTermPartial = jsonData[key].filter((term) => rgxPartial.test(term));

    if (hitKey) {
      results.push({ key, weighted: 4 });
    } else if (hitKeyPartial) {
      results.push({ key, weighted: 2 });
    } else if (hitTerm.length) {
      results.push({ key, weighted: 3 });
    } else if (hitTermPartial.length) {
      results.push({ key, weighted: 1 });
    }
  });

  return results.sort(sortResult).map((item) => item.key);
};

export const searchIcons = (term = '') => {
  if (!term) {
    // return the whole icon set when no search term is supplied
    return Object.keys(jsonData);
  }
  // split search time by space and dash and do a search for each item
  const results = term.split(/[- ]/).map((term) => lookupIcons(term));
  // remove results that don't appear in every search terms result
  return intersection(...results);
};

export const fontJson = jsonData;
